var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social icon for IMX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#17B5CB",
    d: "M3.5 29.1H0l10.73-12.4c.34-.4.34-1 0-1.38L.09 3h3.36l10.7 12.4c.28.38.33.9.03 1.25C11.38 19.9 3.5 29.11 3.5 29.11ZM31.93 3h-3.36L15.03 18.77c-.34.4-.36 1.01-.02 1.4l.37.46 7.25 8.48h3.5l-7.85-9.14a1.08 1.08 0 0 1 .02-1.4L31.93 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17B5CB",
    d: "M20.77 19.02c-.07.33 0 .7.23.95l7.82 9.14H32L21.99 17.53l-.9.99c-.14.13-.26.32-.32.5ZM6.12 3h3.23s5.78 6.9 7.85 9.02c.34.35.27.79-.03 1.13l-1.12 1.34L6.12 3ZM19.02 11.01 25.9 3h-3.27l-3.6 4.19L18 8.41c-.34.4-.37.99-.02 1.4l1.04 1.2ZM6.15 29.1l6.88-8 1.01 1.2c.35.4.33 1-.02 1.4l-1.04 1.22L9.4 29.1H6.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImx);
export default __webpack_public_path__ + "static/media/imx.878821e608a53767579a1a2df2feaa07.svg";
export { ForwardRef as ReactComponent };